import { useMantineColorScheme, useMantineTheme } from "@mantine/core"

export const useChartColors = () => {
  const { colorScheme } = useMantineColorScheme()
  const theme = useMantineTheme()

  // For charts, we need actual color values, not CSS variables
  // Use the appropriate color based on the color scheme
  const axisTextStyle = {
    fill:
      colorScheme === "dark"
        ? theme.colors.darkTextPrimary[0]
        : theme.colors.lightTextPrimary[0],
  }

  const mantineColorNameToColor = (name: string) => {
    const [color, shade] = name.split(".")
    return `var(--mantine-color-${color}-${shade})`
  }

  return {
    colorScheme,
    axisTextStyle,
    mantineColorNameToColor,
  }
}
